/**
 * Generated by orval v8.7.0 🍺
 * Do not edit manually.
 * Agentiq.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AutomationFollowUpDraftResponse,
  AutomationInboxDetailResponse,
  AutomationInboxListResponse,
  AutomationNotificationRecord,
  GetApiAutomationInboxParams,
  GetApiNotificationsParams,
  LightweightAutomationRecord,
  LightweightAutomationRunRecord,
  LightweightAutomationRunResponse,
  ListLightweightAutomationRunsRequest,
  OkResponse,
  RunLightweightAutomationRequest,
  SaveLightweightAutomationRequest
} from '../control-api.schemas';

import { orvalControlFetch } from '../../orval-fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getGetApiLightweightAutomationsUrl = () => {




  return `/api/lightweight-automations`
}

export const getApiLightweightAutomations = async ( options?: RequestInit): Promise<LightweightAutomationRecord[]> => {

  return orvalControlFetch<LightweightAutomationRecord[]>(getGetApiLightweightAutomationsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApiLightweightAutomationsQueryKey = () => {
    return [
    `/api/lightweight-automations`
    ] as const;
    }


export const getGetApiLightweightAutomationsQueryOptions = <TData = Awaited<ReturnType<typeof getApiLightweightAutomations>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiLightweightAutomations>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiLightweightAutomationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiLightweightAutomations>>> = ({ signal }) => getApiLightweightAutomations({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiLightweightAutomations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiLightweightAutomationsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiLightweightAutomations>>>
export type GetApiLightweightAutomationsQueryError = unknown


export function useGetApiLightweightAutomations<TData = Awaited<ReturnType<typeof getApiLightweightAutomations>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiLightweightAutomations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLightweightAutomations>>,
          TError,
          Awaited<ReturnType<typeof getApiLightweightAutomations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiLightweightAutomations<TData = Awaited<ReturnType<typeof getApiLightweightAutomations>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiLightweightAutomations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLightweightAutomations>>,
          TError,
          Awaited<ReturnType<typeof getApiLightweightAutomations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiLightweightAutomations<TData = Awaited<ReturnType<typeof getApiLightweightAutomations>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiLightweightAutomations>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiLightweightAutomations<TData = Awaited<ReturnType<typeof getApiLightweightAutomations>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiLightweightAutomations>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiLightweightAutomationsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getPostApiLightweightAutomationsUrl = () => {




  return `/api/lightweight-automations`
}

export const postApiLightweightAutomations = async (saveLightweightAutomationRequest: SaveLightweightAutomationRequest, options?: RequestInit): Promise<LightweightAutomationRecord> => {

  return orvalControlFetch<LightweightAutomationRecord>(getPostApiLightweightAutomationsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      saveLightweightAutomationRequest,)
  }
);}




export const getPostApiLightweightAutomationsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiLightweightAutomations>>, TError,{data: SaveLightweightAutomationRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiLightweightAutomations>>, TError,{data: SaveLightweightAutomationRequest}, TContext> => {

const mutationKey = ['postApiLightweightAutomations'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiLightweightAutomations>>, {data: SaveLightweightAutomationRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiLightweightAutomations(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiLightweightAutomationsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiLightweightAutomations>>>
    export type PostApiLightweightAutomationsMutationBody = SaveLightweightAutomationRequest
    export type PostApiLightweightAutomationsMutationError = unknown

    export const usePostApiLightweightAutomations = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiLightweightAutomations>>, TError,{data: SaveLightweightAutomationRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiLightweightAutomations>>,
        TError,
        {data: SaveLightweightAutomationRequest},
        TContext
      > => {
      return useMutation(getPostApiLightweightAutomationsMutationOptions(options), queryClient);
    }
    export const getGetApiLightweightAutomationsAutomationIdUrl = (automationId: string,) => {




  return `/api/lightweight-automations/${automationId}`
}

export const getApiLightweightAutomationsAutomationId = async (automationId: string, options?: RequestInit): Promise<LightweightAutomationRecord> => {

  return orvalControlFetch<LightweightAutomationRecord>(getGetApiLightweightAutomationsAutomationIdUrl(automationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApiLightweightAutomationsAutomationIdQueryKey = (automationId: string,) => {
    return [
    `/api/lightweight-automations/${automationId}`
    ] as const;
    }


export const getGetApiLightweightAutomationsAutomationIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiLightweightAutomationsAutomationId>>, TError = unknown>(automationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiLightweightAutomationsAutomationId>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiLightweightAutomationsAutomationIdQueryKey(automationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiLightweightAutomationsAutomationId>>> = ({ signal }) => getApiLightweightAutomationsAutomationId(automationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(automationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiLightweightAutomationsAutomationId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiLightweightAutomationsAutomationIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiLightweightAutomationsAutomationId>>>
export type GetApiLightweightAutomationsAutomationIdQueryError = unknown


export function useGetApiLightweightAutomationsAutomationId<TData = Awaited<ReturnType<typeof getApiLightweightAutomationsAutomationId>>, TError = unknown>(
 automationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiLightweightAutomationsAutomationId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLightweightAutomationsAutomationId>>,
          TError,
          Awaited<ReturnType<typeof getApiLightweightAutomationsAutomationId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiLightweightAutomationsAutomationId<TData = Awaited<ReturnType<typeof getApiLightweightAutomationsAutomationId>>, TError = unknown>(
 automationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiLightweightAutomationsAutomationId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLightweightAutomationsAutomationId>>,
          TError,
          Awaited<ReturnType<typeof getApiLightweightAutomationsAutomationId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiLightweightAutomationsAutomationId<TData = Awaited<ReturnType<typeof getApiLightweightAutomationsAutomationId>>, TError = unknown>(
 automationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiLightweightAutomationsAutomationId>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiLightweightAutomationsAutomationId<TData = Awaited<ReturnType<typeof getApiLightweightAutomationsAutomationId>>, TError = unknown>(
 automationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiLightweightAutomationsAutomationId>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiLightweightAutomationsAutomationIdQueryOptions(automationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getDeleteApiLightweightAutomationsAutomationIdUrl = (automationId: string,) => {




  return `/api/lightweight-automations/${automationId}`
}

export const deleteApiLightweightAutomationsAutomationId = async (automationId: string, options?: RequestInit): Promise<OkResponse> => {

  return orvalControlFetch<OkResponse>(getDeleteApiLightweightAutomationsAutomationIdUrl(automationId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteApiLightweightAutomationsAutomationIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiLightweightAutomationsAutomationId>>, TError,{automationId: string}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiLightweightAutomationsAutomationId>>, TError,{automationId: string}, TContext> => {

const mutationKey = ['deleteApiLightweightAutomationsAutomationId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiLightweightAutomationsAutomationId>>, {automationId: string}> = (props) => {
          const {automationId} = props ?? {};

          return  deleteApiLightweightAutomationsAutomationId(automationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiLightweightAutomationsAutomationIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiLightweightAutomationsAutomationId>>>

    export type DeleteApiLightweightAutomationsAutomationIdMutationError = unknown

    export const useDeleteApiLightweightAutomationsAutomationId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiLightweightAutomationsAutomationId>>, TError,{automationId: string}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiLightweightAutomationsAutomationId>>,
        TError,
        {automationId: string},
        TContext
      > => {
      return useMutation(getDeleteApiLightweightAutomationsAutomationIdMutationOptions(options), queryClient);
    }
    export const getPostApiLightweightAutomationRunNowUrl = () => {




  return `/api/lightweight-automation/run-now`
}

export const postApiLightweightAutomationRunNow = async (runLightweightAutomationRequest: RunLightweightAutomationRequest, options?: RequestInit): Promise<LightweightAutomationRunResponse> => {

  return orvalControlFetch<LightweightAutomationRunResponse>(getPostApiLightweightAutomationRunNowUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      runLightweightAutomationRequest,)
  }
);}




export const getPostApiLightweightAutomationRunNowMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiLightweightAutomationRunNow>>, TError,{data: RunLightweightAutomationRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiLightweightAutomationRunNow>>, TError,{data: RunLightweightAutomationRequest}, TContext> => {

const mutationKey = ['postApiLightweightAutomationRunNow'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiLightweightAutomationRunNow>>, {data: RunLightweightAutomationRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiLightweightAutomationRunNow(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiLightweightAutomationRunNowMutationResult = NonNullable<Awaited<ReturnType<typeof postApiLightweightAutomationRunNow>>>
    export type PostApiLightweightAutomationRunNowMutationBody = RunLightweightAutomationRequest
    export type PostApiLightweightAutomationRunNowMutationError = unknown

    export const usePostApiLightweightAutomationRunNow = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiLightweightAutomationRunNow>>, TError,{data: RunLightweightAutomationRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiLightweightAutomationRunNow>>,
        TError,
        {data: RunLightweightAutomationRequest},
        TContext
      > => {
      return useMutation(getPostApiLightweightAutomationRunNowMutationOptions(options), queryClient);
    }
    export const getPostApiLightweightAutomationRunsUrl = () => {




  return `/api/lightweight-automation/runs`
}

export const postApiLightweightAutomationRuns = async (listLightweightAutomationRunsRequestNull: ListLightweightAutomationRunsRequest | null, options?: RequestInit): Promise<LightweightAutomationRunRecord[]> => {

  return orvalControlFetch<LightweightAutomationRunRecord[]>(getPostApiLightweightAutomationRunsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      listLightweightAutomationRunsRequestNull,)
  }
);}




export const getPostApiLightweightAutomationRunsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiLightweightAutomationRuns>>, TError,{data: ListLightweightAutomationRunsRequest | null}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiLightweightAutomationRuns>>, TError,{data: ListLightweightAutomationRunsRequest | null}, TContext> => {

const mutationKey = ['postApiLightweightAutomationRuns'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiLightweightAutomationRuns>>, {data: ListLightweightAutomationRunsRequest | null}> = (props) => {
          const {data} = props ?? {};

          return  postApiLightweightAutomationRuns(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiLightweightAutomationRunsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiLightweightAutomationRuns>>>
    export type PostApiLightweightAutomationRunsMutationBody = ListLightweightAutomationRunsRequest | null
    export type PostApiLightweightAutomationRunsMutationError = unknown

    export const usePostApiLightweightAutomationRuns = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiLightweightAutomationRuns>>, TError,{data: ListLightweightAutomationRunsRequest | null}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiLightweightAutomationRuns>>,
        TError,
        {data: ListLightweightAutomationRunsRequest | null},
        TContext
      > => {
      return useMutation(getPostApiLightweightAutomationRunsMutationOptions(options), queryClient);
    }
    export const getGetApiAutomationInboxUrl = (params?: GetApiAutomationInboxParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/automation-inbox?${stringifiedParams}` : `/api/automation-inbox`
}

export const getApiAutomationInbox = async (params?: GetApiAutomationInboxParams, options?: RequestInit): Promise<AutomationInboxListResponse> => {

  return orvalControlFetch<AutomationInboxListResponse>(getGetApiAutomationInboxUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApiAutomationInboxQueryKey = (params?: GetApiAutomationInboxParams,) => {
    return [
    `/api/automation-inbox`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiAutomationInboxQueryOptions = <TData = Awaited<ReturnType<typeof getApiAutomationInbox>>, TError = unknown>(params?: GetApiAutomationInboxParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAutomationInbox>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiAutomationInboxQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAutomationInbox>>> = ({ signal }) => getApiAutomationInbox(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiAutomationInbox>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiAutomationInboxQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAutomationInbox>>>
export type GetApiAutomationInboxQueryError = unknown


export function useGetApiAutomationInbox<TData = Awaited<ReturnType<typeof getApiAutomationInbox>>, TError = unknown>(
 params: undefined |  GetApiAutomationInboxParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAutomationInbox>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAutomationInbox>>,
          TError,
          Awaited<ReturnType<typeof getApiAutomationInbox>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiAutomationInbox<TData = Awaited<ReturnType<typeof getApiAutomationInbox>>, TError = unknown>(
 params?: GetApiAutomationInboxParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAutomationInbox>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAutomationInbox>>,
          TError,
          Awaited<ReturnType<typeof getApiAutomationInbox>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiAutomationInbox<TData = Awaited<ReturnType<typeof getApiAutomationInbox>>, TError = unknown>(
 params?: GetApiAutomationInboxParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAutomationInbox>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiAutomationInbox<TData = Awaited<ReturnType<typeof getApiAutomationInbox>>, TError = unknown>(
 params?: GetApiAutomationInboxParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAutomationInbox>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiAutomationInboxQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetApiNotificationsUrl = (params?: GetApiNotificationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/notifications?${stringifiedParams}` : `/api/notifications`
}

export const getApiNotifications = async (params?: GetApiNotificationsParams, options?: RequestInit): Promise<AutomationInboxListResponse> => {

  return orvalControlFetch<AutomationInboxListResponse>(getGetApiNotificationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApiNotificationsQueryKey = (params?: GetApiNotificationsParams,) => {
    return [
    `/api/notifications`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiNotificationsQueryOptions = <TData = Awaited<ReturnType<typeof getApiNotifications>>, TError = unknown>(params?: GetApiNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotifications>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiNotificationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiNotifications>>> = ({ signal }) => getApiNotifications(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiNotifications>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiNotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiNotifications>>>
export type GetApiNotificationsQueryError = unknown


export function useGetApiNotifications<TData = Awaited<ReturnType<typeof getApiNotifications>>, TError = unknown>(
 params: undefined |  GetApiNotificationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotifications>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiNotifications>>,
          TError,
          Awaited<ReturnType<typeof getApiNotifications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiNotifications<TData = Awaited<ReturnType<typeof getApiNotifications>>, TError = unknown>(
 params?: GetApiNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotifications>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiNotifications>>,
          TError,
          Awaited<ReturnType<typeof getApiNotifications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiNotifications<TData = Awaited<ReturnType<typeof getApiNotifications>>, TError = unknown>(
 params?: GetApiNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotifications>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiNotifications<TData = Awaited<ReturnType<typeof getApiNotifications>>, TError = unknown>(
 params?: GetApiNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotifications>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiNotificationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetApiAutomationInboxNotificationIdUrl = (notificationId: string,) => {




  return `/api/automation-inbox/${notificationId}`
}

export const getApiAutomationInboxNotificationId = async (notificationId: string, options?: RequestInit): Promise<AutomationInboxDetailResponse> => {

  return orvalControlFetch<AutomationInboxDetailResponse>(getGetApiAutomationInboxNotificationIdUrl(notificationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApiAutomationInboxNotificationIdQueryKey = (notificationId: string,) => {
    return [
    `/api/automation-inbox/${notificationId}`
    ] as const;
    }


export const getGetApiAutomationInboxNotificationIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiAutomationInboxNotificationId>>, TError = unknown>(notificationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAutomationInboxNotificationId>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiAutomationInboxNotificationIdQueryKey(notificationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAutomationInboxNotificationId>>> = ({ signal }) => getApiAutomationInboxNotificationId(notificationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(notificationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiAutomationInboxNotificationId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiAutomationInboxNotificationIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAutomationInboxNotificationId>>>
export type GetApiAutomationInboxNotificationIdQueryError = unknown


export function useGetApiAutomationInboxNotificationId<TData = Awaited<ReturnType<typeof getApiAutomationInboxNotificationId>>, TError = unknown>(
 notificationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAutomationInboxNotificationId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAutomationInboxNotificationId>>,
          TError,
          Awaited<ReturnType<typeof getApiAutomationInboxNotificationId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiAutomationInboxNotificationId<TData = Awaited<ReturnType<typeof getApiAutomationInboxNotificationId>>, TError = unknown>(
 notificationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAutomationInboxNotificationId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAutomationInboxNotificationId>>,
          TError,
          Awaited<ReturnType<typeof getApiAutomationInboxNotificationId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiAutomationInboxNotificationId<TData = Awaited<ReturnType<typeof getApiAutomationInboxNotificationId>>, TError = unknown>(
 notificationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAutomationInboxNotificationId>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiAutomationInboxNotificationId<TData = Awaited<ReturnType<typeof getApiAutomationInboxNotificationId>>, TError = unknown>(
 notificationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAutomationInboxNotificationId>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiAutomationInboxNotificationIdQueryOptions(notificationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetApiNotificationsNotificationIdUrl = (notificationId: string,) => {




  return `/api/notifications/${notificationId}`
}

export const getApiNotificationsNotificationId = async (notificationId: string, options?: RequestInit): Promise<AutomationInboxDetailResponse> => {

  return orvalControlFetch<AutomationInboxDetailResponse>(getGetApiNotificationsNotificationIdUrl(notificationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApiNotificationsNotificationIdQueryKey = (notificationId: string,) => {
    return [
    `/api/notifications/${notificationId}`
    ] as const;
    }


export const getGetApiNotificationsNotificationIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiNotificationsNotificationId>>, TError = unknown>(notificationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotificationsNotificationId>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiNotificationsNotificationIdQueryKey(notificationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiNotificationsNotificationId>>> = ({ signal }) => getApiNotificationsNotificationId(notificationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(notificationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiNotificationsNotificationId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiNotificationsNotificationIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiNotificationsNotificationId>>>
export type GetApiNotificationsNotificationIdQueryError = unknown


export function useGetApiNotificationsNotificationId<TData = Awaited<ReturnType<typeof getApiNotificationsNotificationId>>, TError = unknown>(
 notificationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotificationsNotificationId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiNotificationsNotificationId>>,
          TError,
          Awaited<ReturnType<typeof getApiNotificationsNotificationId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiNotificationsNotificationId<TData = Awaited<ReturnType<typeof getApiNotificationsNotificationId>>, TError = unknown>(
 notificationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotificationsNotificationId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiNotificationsNotificationId>>,
          TError,
          Awaited<ReturnType<typeof getApiNotificationsNotificationId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiNotificationsNotificationId<TData = Awaited<ReturnType<typeof getApiNotificationsNotificationId>>, TError = unknown>(
 notificationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotificationsNotificationId>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiNotificationsNotificationId<TData = Awaited<ReturnType<typeof getApiNotificationsNotificationId>>, TError = unknown>(
 notificationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotificationsNotificationId>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiNotificationsNotificationIdQueryOptions(notificationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getPostApiAutomationInboxNotificationIdReadUrl = (notificationId: string,) => {




  return `/api/automation-inbox/${notificationId}/read`
}

export const postApiAutomationInboxNotificationIdRead = async (notificationId: string, options?: RequestInit): Promise<AutomationNotificationRecord> => {

  return orvalControlFetch<AutomationNotificationRecord>(getPostApiAutomationInboxNotificationIdReadUrl(notificationId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPostApiAutomationInboxNotificationIdReadMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAutomationInboxNotificationIdRead>>, TError,{notificationId: string}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiAutomationInboxNotificationIdRead>>, TError,{notificationId: string}, TContext> => {

const mutationKey = ['postApiAutomationInboxNotificationIdRead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAutomationInboxNotificationIdRead>>, {notificationId: string}> = (props) => {
          const {notificationId} = props ?? {};

          return  postApiAutomationInboxNotificationIdRead(notificationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiAutomationInboxNotificationIdReadMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAutomationInboxNotificationIdRead>>>

    export type PostApiAutomationInboxNotificationIdReadMutationError = unknown

    export const usePostApiAutomationInboxNotificationIdRead = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAutomationInboxNotificationIdRead>>, TError,{notificationId: string}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiAutomationInboxNotificationIdRead>>,
        TError,
        {notificationId: string},
        TContext
      > => {
      return useMutation(getPostApiAutomationInboxNotificationIdReadMutationOptions(options), queryClient);
    }
    export const getPostApiNotificationsNotificationIdReadUrl = (notificationId: string,) => {




  return `/api/notifications/${notificationId}/read`
}

export const postApiNotificationsNotificationIdRead = async (notificationId: string, options?: RequestInit): Promise<AutomationNotificationRecord> => {

  return orvalControlFetch<AutomationNotificationRecord>(getPostApiNotificationsNotificationIdReadUrl(notificationId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPostApiNotificationsNotificationIdReadMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiNotificationsNotificationIdRead>>, TError,{notificationId: string}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiNotificationsNotificationIdRead>>, TError,{notificationId: string}, TContext> => {

const mutationKey = ['postApiNotificationsNotificationIdRead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiNotificationsNotificationIdRead>>, {notificationId: string}> = (props) => {
          const {notificationId} = props ?? {};

          return  postApiNotificationsNotificationIdRead(notificationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiNotificationsNotificationIdReadMutationResult = NonNullable<Awaited<ReturnType<typeof postApiNotificationsNotificationIdRead>>>

    export type PostApiNotificationsNotificationIdReadMutationError = unknown

    export const usePostApiNotificationsNotificationIdRead = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiNotificationsNotificationIdRead>>, TError,{notificationId: string}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiNotificationsNotificationIdRead>>,
        TError,
        {notificationId: string},
        TContext
      > => {
      return useMutation(getPostApiNotificationsNotificationIdReadMutationOptions(options), queryClient);
    }
    export const getPostApiAutomationInboxNotificationIdFollowUpDraftUrl = (notificationId: string,) => {




  return `/api/automation-inbox/${notificationId}/follow-up-draft`
}

export const postApiAutomationInboxNotificationIdFollowUpDraft = async (notificationId: string, options?: RequestInit): Promise<AutomationFollowUpDraftResponse> => {

  return orvalControlFetch<AutomationFollowUpDraftResponse>(getPostApiAutomationInboxNotificationIdFollowUpDraftUrl(notificationId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPostApiAutomationInboxNotificationIdFollowUpDraftMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAutomationInboxNotificationIdFollowUpDraft>>, TError,{notificationId: string}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiAutomationInboxNotificationIdFollowUpDraft>>, TError,{notificationId: string}, TContext> => {

const mutationKey = ['postApiAutomationInboxNotificationIdFollowUpDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAutomationInboxNotificationIdFollowUpDraft>>, {notificationId: string}> = (props) => {
          const {notificationId} = props ?? {};

          return  postApiAutomationInboxNotificationIdFollowUpDraft(notificationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiAutomationInboxNotificationIdFollowUpDraftMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAutomationInboxNotificationIdFollowUpDraft>>>

    export type PostApiAutomationInboxNotificationIdFollowUpDraftMutationError = unknown

    export const usePostApiAutomationInboxNotificationIdFollowUpDraft = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAutomationInboxNotificationIdFollowUpDraft>>, TError,{notificationId: string}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiAutomationInboxNotificationIdFollowUpDraft>>,
        TError,
        {notificationId: string},
        TContext
      > => {
      return useMutation(getPostApiAutomationInboxNotificationIdFollowUpDraftMutationOptions(options), queryClient);
    }
    export const getPostApiNotificationsNotificationIdFollowUpDraftUrl = (notificationId: string,) => {




  return `/api/notifications/${notificationId}/follow-up-draft`
}

export const postApiNotificationsNotificationIdFollowUpDraft = async (notificationId: string, options?: RequestInit): Promise<AutomationFollowUpDraftResponse> => {

  return orvalControlFetch<AutomationFollowUpDraftResponse>(getPostApiNotificationsNotificationIdFollowUpDraftUrl(notificationId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPostApiNotificationsNotificationIdFollowUpDraftMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiNotificationsNotificationIdFollowUpDraft>>, TError,{notificationId: string}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiNotificationsNotificationIdFollowUpDraft>>, TError,{notificationId: string}, TContext> => {

const mutationKey = ['postApiNotificationsNotificationIdFollowUpDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiNotificationsNotificationIdFollowUpDraft>>, {notificationId: string}> = (props) => {
          const {notificationId} = props ?? {};

          return  postApiNotificationsNotificationIdFollowUpDraft(notificationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiNotificationsNotificationIdFollowUpDraftMutationResult = NonNullable<Awaited<ReturnType<typeof postApiNotificationsNotificationIdFollowUpDraft>>>

    export type PostApiNotificationsNotificationIdFollowUpDraftMutationError = unknown

    export const usePostApiNotificationsNotificationIdFollowUpDraft = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiNotificationsNotificationIdFollowUpDraft>>, TError,{notificationId: string}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiNotificationsNotificationIdFollowUpDraft>>,
        TError,
        {notificationId: string},
        TContext
      > => {
      return useMutation(getPostApiNotificationsNotificationIdFollowUpDraftMutationOptions(options), queryClient);
    }
